// A chat is its membership, so its kind is read off `memberIds` and cannot
// disagree with it — there is no `type` field on the document and there will
// not be one. `'assistant'` is a reserved member id, not a flag: dropping it
// into a group chat is all it takes to make the assistant answer there.

export const ASSISTANT_ID = 'assistant';
export const ASSISTANT_NAME = 'Muva Assistant';

// Derived, never looked up and never stored on the user document
export const assistantChatId = (uid) => `assistant_${uid}`;

export const isAssistantChat = (chat) =>
  !!chat?.memberIds?.includes(ASSISTANT_ID);

export const otherMemberId = (chat, uid) =>
  chat?.memberIds?.find((id) => id !== uid) ?? null;

// Everyone whose user document the window needs read by id. The assistant has
// none, and neither does the viewer's own entry.
export const otherMemberIds = (chats, uid) => [
  ...new Set(
    chats.flatMap(
      (chat) =>
        chat?.memberIds?.filter((id) => id !== uid && id !== ASSISTANT_ID) ??
        [],
    ),
  ),
];

// The name the window shows. `senderName` on a message is a snapshot taken
// when it was written, so a current name is read from the user document
// wherever one is available.
export const chatTitle = (chat, uid, usersById) => {
  if (isAssistantChat(chat)) return ASSISTANT_NAME;
  if (chat?.title) return chat.title;

  const otherId = otherMemberId(chat, uid);
  return (
    usersById?.get(otherId)?.name ?? chat?.lastMessage?.senderName ?? 'Chat'
  );
};

// Who a message is from, for the bubble. The assistant carries no name of its
// own on either a notification or a reply.
export const senderName = (message, usersById) => {
  if (message?.senderId === ASSISTANT_ID) return ASSISTANT_NAME;
  return (
    usersById?.get(message?.senderId)?.name ?? message?.senderName ?? 'Unknown'
  );
};
